import { SaveButton } from "components/Buttons"
import ModalComponent from "components/Modals"
import Table from "components/Table"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Row, Col } from "reactstrap"
import {
  getWebAlerts,
  hideSendWebAlertModal,
  openSendWebAlertModal,
  sendWebAlert,
} from "store/actions"
import webAlertsListColumns from "./webAlertsListColumns"
import SendWebAlerForm from "./sendWebAlertForm"
import { userIsGodMode } from "utils"

const WebAlerts = ({
  loading,
  webAlerts,
  getWebAlerts,
  isSendWebAlertModalOpen,
  openSendWebAlertModal,
  hideSendWebAlertModal,
  sendWebAlert,
}) => {
  useEffect(() => {
    const userIsGodModes = userIsGodMode()
    if (userIsGodModes) {
      getWebAlerts()
    }
  }, [])

  const sendWebAlertHandler = data => {
    sendWebAlert({
      title: data?.alert_title,
      text: data?.alert_text,
      type: data?.alert_type,
      callback: getWebAlerts,
    })
  }

  return (
    <React.Fragment>
      <Row className={"my-2 d-flex justify-content-end"}>
        <Col xs={12} sm={5} md={4} xl={2} className={"mb-2"}>
          <SaveButton
            type="button"
            fullWidth={true}
            content="Send Web Alert"
            onClick={openSendWebAlertModal}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <h5>
            These alerts have been sent to all users from all clients, not just
            to the ones from this client.
          </h5>
        </Col>
      </Row>
      <Row className={"my-3"}>
        <Col>
          <Table
            columns={webAlertsListColumns()}
            data={webAlerts || []}
            loadingData={loading}
          />
        </Col>
      </Row>
      <ModalComponent
        open={isSendWebAlertModalOpen}
        onClose={hideSendWebAlertModal}
        title="Send Web Alert"
      >
        <SendWebAlerForm
          onSubmit={sendWebAlertHandler}
          handleClose={hideSendWebAlertModal}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loading: state.Communications.loading,
  webAlerts: state.Communications.webAlerts,
  isSendWebAlertModalOpen: state.Communications.isSendWebAlertModalOpen,
})

const mapDispatchToProps = dispatch => ({
  getWebAlerts: values => dispatch(getWebAlerts(values)),
  openSendWebAlertModal: () => dispatch(openSendWebAlertModal()),
  hideSendWebAlertModal: () => dispatch(hideSendWebAlertModal()),
  sendWebAlert: values => dispatch(sendWebAlert(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(WebAlerts)